"use client";
import { Image } from "antd";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { useState } from "react";

type Props = {
    productImages: any[];
}

type ProductItem = {
    name: string;
    src: string;
}

export default function ProductViewer({ productImages }: Props) {
    const [activeIndex, setActiveIndex] = useState(0);

    // 切换图片
    const handleSwitch = (controlType: string, index: number) => {
        if (controlType === "prev" && activeIndex > 0) {
            setActiveIndex(activeIndex - 1);
        } else if (controlType === "next" && activeIndex < productImages.length - 1) {
            setActiveIndex(activeIndex + 1);
        } else if (controlType === "specific") {
            setActiveIndex(index);
        }
    }

    return <div className="flex-1 overflow-hidden">
        <div className="w-full h-[392px] ">
            <Image preview={false} src={productImages[activeIndex]?.src} />
        </div>

        <div className="flex flex-row mt-[30px]">
            <LeftOutlined className="cursor-pointer text-[#ccc] hover:text-main select-none" onClick={() => handleSwitch("prev", 0)} />
            <div className="flex flex-auto overflow-hidden justify-center gap-4">
                {/* 暂时最多支持三张图片 */}
                {
                    productImages.map((item: ProductItem, index: number) => {
                        return <div
                            className={`w-[90px] h-[90px] cursor-pointer border  hover:border-main ${activeIndex === index ? 'border-main' : 'border-[#dbdbdb]'}`}
                            onClick={() => handleSwitch("specific", index)}
                            key={index}
                        >
                            <Image preview={false} src={item.src} />
                        </div>
                    })
                }
            </div>
            <RightOutlined className="cursor-pointer text-[#ccc] hover:text-main select-none" onClick={() => handleSwitch("next", 0)} />
        </div>

    </div>
}